// extracted by mini-css-extract-plugin
export default {"m":"375px","t":"768px","md":"1024px","d":"1280px","xl":"1440px","xxl":"1600px","xxxl":"1920px"};